import React from 'react';
import { Typography, Stack } from '@mui/material';

interface MessageProps {
  message: any;
}

const MessagePayment: React.FC<MessageProps> = ({ message }) => {
  const displayData = message?.content?.text;

  if (!displayData || typeof displayData !== 'object') {
    return <Typography variant="body2">Payment details not available</Typography>;
  }

  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2" fontWeight="bold">
        Payment Details
      </Typography>
      {Object.entries(displayData).map(([key, value]) => (
        <Typography key={key} variant="body2">
          <strong>{key}:</strong>{' '}
          {typeof value === 'object' ? JSON.stringify(value) : String(value)}
        </Typography>
      ))}
    </Stack>
  );
};

export default MessagePayment;
